import { MouseEvent, useState } from 'react';
import clsx from 'clsx';

import { InfoIconDark } from 'shared/ui/info-icon-dark';
import { Tooltip } from 'shared/ui/tooltip';
import { eventService, XApiEventKeys } from 'shared/api/event-service';

import { LITERACY_INSIGHT_TOOLTIP_LINK_HREF } from './constants';
import styles from './styles.module.scss';

type LiteracyInsightHeadingProps = {
  header?: string;
  isPreviewSection?: boolean;
};

export const LiteracyInsightHeading = ({
  header,
  isPreviewSection = true,
}: LiteracyInsightHeadingProps) => {
  const [shouldShowDarkInfoIcon, setShouldShowDarkInfoIcon] = useState(false);

  const handleTooltipStateChange = (isTooltipVisible: boolean) => {
    setShouldShowDarkInfoIcon(isTooltipVisible);

    if (isTooltipVisible) {
      eventService.send(
        XApiEventKeys.selectedLiteracyInsightsTooltip,
        undefined,
        {
          result: {
            isRightClick: false,
          },
        },
      );
    }
  };

  const handleLearnMoreLinkClick = (e: MouseEvent) => {
    eventService.send(
      XApiEventKeys.selectedTLiteracyInsightsTooltipLink,
      {
        result: {
          destinationUrl: LITERACY_INSIGHT_TOOLTIP_LINK_HREF,
        },
      },
      {
        result: {
          isRightClick: e.type === 'contextmenu',
        },
      },
    );
  };

  const tooltipMessage = (
    <>
      <span className={styles.tooltipMessage}>
        The Weekly Insight uses data from your classroom&apos;s recent
        performance in Boost Reading to share recommendations for your CKLA
        instruction.
      </span>
      <span className={styles.tooltipMessage}>
        Learn more about how insights and recommendations are generated{' '}
        <a
          className={styles.tooltipLink}
          href={LITERACY_INSIGHT_TOOLTIP_LINK_HREF}
          target="_blank"
          rel="noreferrer"
          onClick={handleLearnMoreLinkClick}
          onContextMenu={handleLearnMoreLinkClick}
        >
          <span>here</span>
          <i className="icon-v2-new-tab" aria-hidden />
        </a>
      </span>
    </>
  );

  return (
    <div
      className={clsx(styles.heading, {
        [styles.previewSection]: isPreviewSection,
      })}
    >
      <div className={styles.titleRow}>
        <div
          className={clsx(styles.title, {
            [styles.previewSection]: isPreviewSection,
          })}
        >
          {header}
        </div>
        {isPreviewSection && (
          <Tooltip
            tooltipStateCallback={handleTooltipStateChange}
            title={tooltipMessage}
            wrapperClassNames={styles.tooltipWrapper}
            tooltipClassNames={styles.tooltipContent}
            showOnHover={false}
            testId="literacy-insight-heading-tooltip"
            showCloseIcon
          >
            <button
              type="button"
              className={clsx('btn btn-icon-ghost', styles.infoIconButton)}
              data-testid="literacy-insight-heading-btn"
            >
              {shouldShowDarkInfoIcon ? (
                <InfoIconDark />
              ) : (
                <i className="icon-v2-information" aria-hidden />
              )}
            </button>
          </Tooltip>
        )}
      </div>
      <div className={styles.subtitle}>CKLA insights, powered by Boost</div>
    </div>
  );
};
